import React, { useMemo } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { loginMenuLinks } from "@/components/header/content"
import { isUndefined } from "@/shared/FunctionCore";

const LoginDropdown = ({
  setLoginMenuOpen,
  countryCode
}) => {
  const { t } = useTranslation();
  const menuLinksData = useMemo(() => {
    return loginMenuLinks[countryCode]
  }, [countryCode])

  if (isUndefined(menuLinksData)) return <></>;

  // if (!isNotUndefinedOrNull(Object.keys(menuLinksData))) return <></>;

  return (
    <>
      <div className="product-login-container">
        <div className="submenu">
          <div className="product-data one">
            <p>{menuLinksData.headingDnbProduct}</p>
            <ul className="productList">
              {menuLinksData.dnbProductsData?.map((item, index) => (
                <li className="product" key={`link-${index}`}>
                  <a
                    // className={classnames({ "title": true, "ext-icon": item.onNewTab })}
                    href={item.url}
                    target={item.onNewTab ? "_blank" : "_self"}
                  >
                    {item.linkName}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="product-data">
            <p>{menuLinksData.headingMyCompanyInfo}</p>
            <ul className="myCompanyInfoList">
              {menuLinksData.myCompanyInfoData?.map((item, index) => (
                <li className="product" key={`link-${index}`}>
                  <a
                    // className={classnames({ "title": true, "ext-icon": item.onNewTab })}
                    href={item.url}
                    target={item.onNewTab ? "_blank" : "_self"}
                  >
                    {item.linkName}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* <div className="row">


            {Object.keys(menuLinksData).map((heading, i) => {
              const menuLinks = menuLinksData[heading];

              return (
                <div className="col-md-6" key={`login-menu-${i}`}>
                  <div className="group">
                    <a className="category title finance">
                      <p dangerouslySetInnerHTML={{ __html: heading }}></p>
                    </a>
                    <div className="submenu">
                      <ul>
                        {menuLinks?.map((item, index) => (
                          <li className="product" key={`link-${index}`}>
                            <a
                              className={classnames({ "title": true, "ext-icon": item.onNewTab })}
                              href={item.url}
                              target={item.onNewTab ? "_blank" : "_self"}
                            >
                              {item.linkName}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              )
            })}
          </div> */}
      </div>
      <button
        onClick={() => {
          setLoginMenuOpen(false)
        }}
        id="productLoginCloseButton"
        className="consolidatedHeaderProductLoginCloseButton close"
        type="button"
      ></button>
    </>
  )
}

export default LoginDropdown;